'use strict';

var charts = require('./charts');

function renderCharts () {
  $('.part.chart:not(.rendered)')
    .addClass('rendered')
    .each(function (index, partElm) {
      var $part, data, type;

      $part = $(partElm);
      data = null;
      try {
        data = JSON.parse($part.find('.data').text());
      } catch (_error) {
        return;
      }

      type = $part.data('type');

      switch (type) {
        case 'line-chart':
          return charts.line($part, data);
        case 'line-time':
          return charts.lineTime($part, data);
        case 'geo':
          return charts.geo($part, data);
        case 'pie':
          return charts.pie($part, data);
        case 'gender-age-chart':
          return charts.genderAge($part, data);
        default:
          return charts.render($part, data, type);
      }
    });
}

module.exports = renderCharts;
